import React, { Component } from "react"
import Helmet from "react-helmet"
import "../css/Hide.css"
import Link from "gatsby-link"
import get from "lodash/get"
import styled from "styled-components"
import {
  TINY_SHADOW,
  TINY_BKG,
  SECONDARY_TEXT
} from "../components/consts/colors.js"
import blogBG from "../assets/blog-bg.svg"
import Icon from "../components/Icons"

import Tags from "../components/Tags"

const BlogPostContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  background-color: ${TINY_BKG};

  @media screen and (max-width: 615px) {
    background-color: white;
  }
`

const BlogPostBackground = styled.div`
  display: flex;
  position: absolute;
  width: 100vw;
  height: 140vh;
  bottom: 200px;
  background-image: url(${blogBG});
  background-size: cover;
  background-position: top;
`

const BlogPost = styled.div`
  display: flex;
  position: relative;
  z-index: 3;
  flex-direction: column;
  align-items: flex-start;
  width: 750px;
  margin: 150px 25px 25px 25px;
  padding: 50px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 4px 10px ${TINY_SHADOW};

  h5 {
    margin: 0px 10px;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
  @media screen and (max-width: 615px) {
    width: 100%;
    border-radius: 0px;
    box-shadow: 0px 4px 0px transparent;
  }
`

const BlogPostContent = styled.div`
  margin: 20px 10px;
  h1 {
    font-weight: normal;
    font-size: 28px;
    letter-spacing: 0.1px;
    margin: 10px 0px 30px 0px;
  }
  h3 {
    font-weight: normal;
    font-size: 22px;
    letter-spacing: 0.1px;
    margin: 35px 0px 5px 0px;
  }
  p {
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.1px;
    margin: 0px 0px 25px 0px;
    :last-child {
      margin-top: 50px;
    }
  }
  em {
    display: flex;
    position: relative;
    top: -20px;
    margin: 0px 50px;
    font-size: 14px;
    color: ${SECONDARY_TEXT};
    text-align: center;
    line-height: 18px;
  }
  a:hover {
  }
`
const NextPost = styled.div`
  width: 700px;
  display: flex;
  justify-content: center;
  margin: 0px 0px 150px 0px;

  a {
    display: flex;
    padding: 0px 25px;
    transition: all 200ms ease;
    :hover {
      transform: translateY(-2px);
    }
  }
  h5 {
    font-weight: 400;
  }
  div {
    position: relative;
    top: 3px;
    padding: 0px 10px;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
  @media screen and (max-width: 615px) {
    align-items: center;
    flex-direction: column;
    justify-content: center;
    a {
      padding: 10px 0px;
    }

    div {
      position: relative;
      top: 0px;
      padding: 0px 10px;
      :nth-child(1) {
        padding-left: 0;
      }
      :nth-child(2) {
        padding-right: 0;
      }
    }
  }
`
const BackToBlog = styled.div`
  position: relative;
  top: -100px;
  display: flex;
  a {
    color: white;
    display: flex;
    transition: all 200ms ease;
    :hover {
      transform: translateX(-3px);
    }
    div {
      padding-right: 10px;
      position: relative;
      top: 1px;
    }
  }
`

export default function Template({ data, pathContext }) {
  const { markdownRemark: post } = data
  const { next, prev } = pathContext
  return (
    <BlogPostContainer>
      <Helmet title={`TinyMerch - ${post.frontmatter.title}`} />
      <BlogPostBackground />
      <BlogPost>
        <BackToBlog>
          <Link to="/blog">
            <Icon name="back" color="white" />Back to Blog
          </Link>
        </BackToBlog>
        <h5>{post.frontmatter.title}</h5>
        <BlogPostContent dangerouslySetInnerHTML={{ __html: post.html }} />
      </BlogPost>
      <NextPost>
        {prev && (
          <Link to={prev.frontmatter.path}>
            <Icon name="back" color="#6079F2" />{" "}
            <h5>{prev.frontmatter.title}</h5>
          </Link>
        )}
        {next && (
          <Link to={next.frontmatter.path}>
            <h5>{next.frontmatter.title}</h5>{" "}
            <Icon name="forward" color="#6079F2" />
          </Link>
        )}
      </NextPost>
    </BlogPostContainer>
  )
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js